import styled from '@emotion/styled';
import { Typography } from 'antd';

export const STrigger = styled.div`
  border: 1px solid #D9D9D9;
  padding: 5px 16px;
  display: inline-block;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.016);
  background: white;
  cursor: pointer;
`;

export const SIconWrapper = styled.div`
  margin-left: 8px;
  width: 8px;
  height: 5px;
  display: inline-block;
  svg {
    width: 100%;
  }
`;

export const SLabel = styled(Typography.Text)`
  font-size: 14px;
`;
